export function getPrecision(value: string): number {
  const isDecimal = value.includes('.');

  return isDecimal ? value.length - value.indexOf('.') - 1 : 0;
}
